export enum PaymentActionEnum {
  CONFIRM = <any>'confirm',
  REJECT = <any>'reject',
}

export const PaymentActions: string[] = [
  PaymentActionEnum.CONFIRM.toString(),
  PaymentActionEnum.REJECT.toString()
];



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action.enum.ts